import {
  EnvironmentProviders,
  importProvidersFrom,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { ConfigService } from '@app/core/config/config.service';
import {
  FmntsCockpitApiConfiguration,
  FmntsCockpitApiModule,
} from '@fmnts/api/cockpit';
import { AuthStore } from '@formunauts/shared/auth/data-access';
import * as O from 'effect/Option';

export function provideFmntsApi(): EnvironmentProviders {
  return makeEnvironmentProviders([
    {
      provide: FmntsCockpitApiConfiguration,
      useFactory: () => {
        const config = inject(ConfigService);
        const authStore = inject(AuthStore);

        const basePath = `${config.settings.apiUrl}api-cockpit/v2`;
        return new FmntsCockpitApiConfiguration({
          basePath,
          credentials: {
            BearerAuth: () =>
              authStore.session().pipe(
                O.map((s) => s.access_token),
                O.getOrUndefined,
              ),
          },
        });
      },
    },
    importProvidersFrom(FmntsCockpitApiModule),
  ]);
}
